export default __webpack_public_path__ + "static/promo_1-c4c42e51f4189607afe60c272c372328.webp";